import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "content", "size", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "paddingX", "paddingY", "style", "verticalAlign", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { ColorPreset, Enum, getColorClass, isType, useSpacingProps } from '../../../library';
export var IconSize = Enum('small', 'medium', 'large');
var iconSizeMap = {
  small: 12,
  medium: 16,
  large: 24
};
export var Icon = React.forwardRef(function (props, ref) {
  var className = props.className,
    color = props.color,
    content = props.content,
    size = props.size,
    margin = props.margin,
    marginBottom = props.marginBottom,
    marginLeft = props.marginLeft,
    marginRight = props.marginRight,
    marginTop = props.marginTop,
    marginX = props.marginX,
    marginY = props.marginY,
    padding = props.padding,
    paddingBottom = props.paddingBottom,
    paddingLeft = props.paddingLeft,
    paddingRight = props.paddingRight,
    paddingTop = props.paddingTop,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    style = props.style,
    verticalAlign = props.verticalAlign,
    title = props.title,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses;
  var classNames = cn('icon', isType(ColorPreset, color) ? getColorClass(color) : '', marginClasses, className);
  var height = isType(IconSize, props.size) ? iconSizeMap[props.size] : props.size;
  var naturalHeight = closestNaturalHeight(Object.keys(props.content), height);
  var naturalWidth = props.content[naturalHeight].width;
  var width = height * (naturalWidth / naturalHeight);
  var paths = props.content[naturalHeight].source;
  var iconStyles = _objectSpread({
    color: !isType(ColorPreset, color) ? color : undefined,
    verticalAlign: props.verticalAlign
  }, style);
  return React.createElement("svg", _extends({
    ref: ref,
    viewBox: "0 0 ".concat(naturalWidth, " ").concat(naturalHeight),
    height: height,
    width: width,
    "aria-label": props.title,
    "aria-hidden": props.title ? false : true,
    className: classNames,
    style: iconStyles
  }, htmlProps, {
    dangerouslySetInnerHTML: {
      __html: paths
    }
  }));
});
Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 16,
  verticalAlign: 'text-bottom'
};
function closestNaturalHeight(naturalHeights, height) {
  return naturalHeights.map(function (naturalHeight) {
    return parseInt(naturalHeight, 10);
  }).reduce(function (acc, naturalHeight) {
    return naturalHeight <= height ? naturalHeight : acc;
  }, parseInt(naturalHeights[0], 10));
}